import { render, staticRenderFns } from "./CncPage.vue?vue&type=template&id=590a136a"
import script from "./CncPage.vue?vue&type=script&lang=js"
export * from "./CncPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports